import { render, staticRenderFns } from "./voice-edit.vue?vue&type=template&id=e615b830&"
import script from "./voice-edit.vue?vue&type=script&lang=js&"
export * from "./voice-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports